module.exports = __webpack_public_path__ + "static/media/popupIcons.c9824387.png";